class GlobalSiteSwitchDialog extends HTMLElement {
  #endpoint = null;
  constructor() {
    super();

    this.#endpoint = this.getAttribute('data-endpoint');

    if (this.#endpoint != null) {
      this.loadContent();
    }
  }

  async loadContent() {
    try {
      let url = this.#endpoint;

      // If ?country_force is present in the current URL, append it to the fetch URL
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('country_force')) {
        const countryForceValue = urlParams.get('country_force');
        const separator = url.includes('?') ? '&' : '?';
        url += `${separator}country_force=${encodeURIComponent(countryForceValue)}`;
      }

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();

      if (!data) return;

      if (!data.content) return;

      this.innerHTML = data.content;
    } catch (error) {
      console.error('Error loading site switch dialog content:', error);
    }
  }
}

customElements.define('global-site-switch-dialog', GlobalSiteSwitchDialog);
